import { render, staticRenderFns } from "./FlowStepCancelSurvey.vue?vue&type=template&id=6b869d67&scoped=true&"
import script from "./FlowStepCancelSurvey.vue?vue&type=script&lang=js&"
export * from "./FlowStepCancelSurvey.vue?vue&type=script&lang=js&"
import style0 from "./FlowStepCancelSurvey.vue?vue&type=style&index=0&id=6b869d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b869d67",
  null
  
)

export default component.exports